import InfoIcon from '@components/icons/Info.svg';
import { cn } from '@helpers/cn';
import { formatDateMsDsY } from '@helpers/formatDateMsDsY';

import { TProps } from './types/TProps';

const ENDING_SOON_DAYS = 3;

export const FreeTrialBanner = ({
  trialEndDate,
  daysLeft,
  planName,
  seatPrice,
  includesProFeatures,
  className,
}: TProps) => {
  const endDate = formatDateMsDsY(trialEndDate);
  const dayLabel = `${daysLeft} ${daysLeft === 1 ? 'day' : 'days'}`;
  const isEndingSoon = daysLeft <= ENDING_SOON_DAYS;
  const planStart =
    planName && seatPrice ? `your ${planName} plan starts at ${seatPrice}/seat per month` : 'your paid plan starts';

  return (
    <section
      aria-label="Free trial"
      data-testid="free-trial-banner"
      className={cn(
        'flex items-start gap-3 rounded-[10px] px-5 py-4 text-sm leading-normal',
        isEndingSoon
          ? 'bg-[var(--color-warning-bg)] text-[var(--color-warning-text)]'
          : 'bg-[var(--color-info-bg)] text-[var(--color-info-text)]',
        className,
      )}
    >
      <InfoIcon aria-hidden="true" className="h-5 w-5 shrink-0" />
      {isEndingSoon ? (
        <div>
          <p className="m-0 text-base font-semibold">Your free trial ends in {dayLabel}</p>
          <p className="m-0">
            On {endDate}, {planStart}
            {includesProFeatures ? ', and Pro features will no longer be included' : ''}. Cancel before then if you
            don&apos;t want to continue.
          </p>
        </div>
      ) : (
        <div>
          <p className="m-0 text-base font-semibold">
            {includesProFeatures ? "You're on a free trial with every Pro feature unlocked" : "You're on a free trial"}
          </p>
          <p className="m-0">
            Your trial ends on {endDate} ({dayLabel} left). After that, {planStart}. Plan upgrades become available when
            the trial ends.
          </p>
        </div>
      )}
    </section>
  );
};
